import { useState, useEffect } from 'react';

/**
 * Returns `value` delayed by `delayMs` — it only settles once the input has
 * stopped changing for that long. Use it to debounce expensive work driven by
 * fast-changing state (e.g. re-filtering and refetching the visible page's
 * coverage on every keystroke) while keeping the source state instant.
 *
 * @param {*} value - the rapidly-changing value (e.g. a controlled input)
 * @param {number} delayMs - quiet period before the value settles
 * @returns {*} the debounced value
 */
export function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}

export default useDebouncedValue;
